// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import ResponsiveImage from '../../internal/ResponsiveImage';
import type { BlockRichText } from '../../internal/types';

type BackgroundColor = 'Black' | 'Citrus' | 'White' | 'Silver' | 'Charcoal';

type PropTypes = {|
  variant: 'Large' | 'Medium' | 'Small',
  backgroundColor?: BackgroundColor,
  image?: string,
  alt?: string,
  children: BlockRichText,
  author?: string,
  authorTitle?: string,
  authorCompany?: string,
|};

const backgroundMap = {
  Black: 'Dark',
  Citrus: 'Featured',
  White: 'White',
  Silver: 'Silver',
  Charcoal: 'Charcoal',
};

export const QuoteBase = (props: { ...PropTypes, className?: string }) => {
  let quoteBlock;
  const quote = (
    <blockquote className={styles.quote} key="quote">
      {props.children}
    </blockquote>
  );
  const author = props.author && (
    <cite className={styles.attribution} key="author">
      {props.author}
      {props.authorTitle && `, ${props.authorTitle}`}
      {props.authorCompany && `, ${props.authorCompany}`}
    </cite>
  );

  if (props.image && props.variant === 'Large') {
    quoteBlock = (
      <div className={styles.quoteContainer}>
        <div className={styles.imageContainer}>
          <ResponsiveImage
            className={styles.image}
            src={props.image}
            alt={props.alt}
            defaultSize={{ width: 155, height: 155 }}
          />
        </div>
        <div className={styles.textContainer}>
          {quote}
          {author}
        </div>
      </div>
    );
  } else {
    quoteBlock = [quote, author];
  }

  return <div className={cx(props.className, styles[`is${props.variant}`])}>{quoteBlock}</div>;
};

QuoteBase.defaultProps = {
  backgroundColor: 'White',
};

const Quote = (props: PropTypes) => (
  <PageContentBlock layout="Thin" background={backgroundMap[props.backgroundColor || 'White']}>
    <QuoteBase {...props} />
  </PageContentBlock>
);

Quote.defaultProps = {
  variant: 'Medium',
  backgroundColor: 'White',
};

export default Quote;
